import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class MagazineService {

    constructor() {
        this.httpClient = new HttpClient()
    }

    getMagazineItemsList(page, size,type) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `posts`,
                {
                    page, size, type
                }
            ).then(resolve).catch(reject)
        })
    }

    createNewPost(title, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `posts`,
                {
                    title, type
                }
            ).then(resolve).catch(reject)
        })
    }


    getNewsGlobalInfo(id) {

        const newsInformation = this.httpClient.get(
            `posts/${id}/information`,
        );

        const newsPublishedState = this.httpClient.get(
            `posts/${id}/published`,
        );

        const newsContentState = this.httpClient.get(
            `posts/${id}/contents`,
        );

        const requests = [
            newsInformation,
            newsPublishedState,
            newsContentState
        ]

        return new Promise((resolve, reject) => {
            axios.all(requests)
                .then(axios.spread((newsInformation, newsPublished, newsContent) => {
                        resolve({
                            newsInformation, newsPublished, newsContent
                        })
                    })
                ).catch(reject)
        })


    }

    changePublishedState(id, published, publishDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `posts/${id}/published`,
                {},
                {
                    published,
                    publishedAt: publishDate
                }
            ).then(resolve).catch(reject)
        })
    }

    updateNewsInformation(id, title, type, shortDescription) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `posts/${id}/information`,
                {
                    title,
                    shortDescription,
                    timeToRead: "",
                    type
                }
            ).then(resolve).catch(reject)
        })
    }

    updateNewsContent(id, contents) {
        const _content = []
        contents.map((item, index) => {
            _content.push({
                ...item,
                priority: index
            })
        })

        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `posts/${id}/contents`,
                {},
                _content
            ).then(resolve).catch(reject)
        })
    }


    getThumbnailInfo(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `posts/${id}/thumbnails`
            ).then(resolve).catch(reject)
        })
    }

    updateThumbnail(id, file) {
        let data = new FormData()
        data.append('file', file)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "multipart/form-data"
            ).patch(
                `posts/${id}/thumbnails`,
                {},
                data
            ).then(resolve).catch(reject)
        })
    }

    getSeo(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `posts/${id}/seo`,
            ).then(resolve).catch(reject)
        })
    }

    updateSeo(
        id,
        metaTitle,
        metaDescription,
        metaRobots,
        metaKeyboards,
        openGraph
    ) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `posts/${id}/seo`,
                {
                    "metaTile": metaTitle,
                    "metaDescription": metaDescription,
                    "metaRobots": metaRobots,
                    "metaKeyboards": metaKeyboards,
                    "openGraphItems": openGraph
                }
            ).then(resolve).catch(reject)
        })
    }

    getArticleTags(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `posts/${id}/tags`
            ).then(resolve).catch(reject)
        })
    }

    updateCategory(id, categories) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `posts/${id}/categories`,
                {
                    categories
                }
            ).then(resolve).catch(reject)
        })
    }

    getCategory(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `posts/${id}/categories`
            ).then(resolve).catch(reject)
        })
    }

    updateTags(id, tags) {
        const _tags = []
        tags.map((tag, index) => {
            _tags.push(tag.id)
        })

        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `posts/${id}/tags`,
                {
                    tags: _tags
                }
            ).then(resolve).catch(reject)
        })
    }

    updateCornerstone(blogID, id, title, description, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `posts/${blogID}/cornerstone`,
                {
                    "content": {
                        type,
                        id,
                        title,
                        description
                    }
                }
            ).then(resolve).catch(reject)
        })
    }

    getCornerstone(blogID) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `posts/${blogID}/cornerstone`
            ).then(resolve).catch(reject)
        })
    }
}